import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { SignInScreen } from './SignIn';
import { CreateAccountEmailScreen } from './CreateAccount/1/EmailPassword';
import { CreateAccountOTPScreen } from './CreateAccount/2/OTP';
import { CreateAccountVerifyMobileScreen } from './CreateAccount/3/VerifyMobile';
import { CreateAccountPersonalDetailsScreen } from './CreateAccount/4/PersonalDetails';

const useStyles = makeStyles(theme => ({
}));
const Account = ({}) => {
  const classes = useStyles()
  return (
    <Switch>
      <Route exact path="/createbooking/account/signin" component={SignInScreen}/>
      <Route exact path="/createbooking/account/emailpassword" component={CreateAccountEmailScreen}/>
      <Route exact path="/createbooking/account/otp" component={CreateAccountOTPScreen}/>
      <Route exact path="/createbooking/account/verify/:code" component={CreateAccountVerifyMobileScreen}/>
      <Route exact path="/createbooking/account/verify" component={CreateAccountVerifyMobileScreen}/>
      <Route exact path="/createbooking/account/personaldetails" component={CreateAccountPersonalDetailsScreen}/>
    </Switch>
  )
}

export {Account}